import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

export const ADD_RESPONSABLES_SEGURO = `
mutation addResponsablesSeguro($input: InputAddResponsablesSeguro!) {
    addResponsablesSeguro(input: $input) {
        responsableID
        responsable
    }
}
`;

export const UPDATE_RESPONSABLES_SEGURO = `
mutation updateResponsablesSeguro($input: InputUpdateResponsablesSeguro!) {
    updateResponsablesSeguro(input: $input) {
        responsableID
        responsable
    }
}
`;

export const DELETE_RESPONSABLES_SEGURO = `
mutation deleteResponsablesSeguro($input: InputDeleteResponsablesSeguro) {
    deleteResponsablesSeguro(input: $input)
}
`;

export const addResponsablesSeguro = async (variables, token) => {
    try {
        let { addResponsablesSeguro } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: ADD_RESPONSABLES_SEGURO
        });

        return addResponsablesSeguro;

    } catch ({ message }) { throw new Error(message); }
};

export const updateResponsablesSeguro = async (variables, token) => {
    try {
        let { updateResponsablesSeguro } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_RESPONSABLES_SEGURO
        });

        return updateResponsablesSeguro;

    } catch ({ message }) { throw new Error(message); }
};

export const deleteResponsablesSeguro = async (input, token) => {
    try {
        let { deleteResponsablesSeguro } = await FetchAPI.graphql({
            token,
            variables: { input },
            url: urlServidor,
            query: DELETE_RESPONSABLES_SEGURO
        });

        return deleteResponsablesSeguro;

    } catch ({ message }) { throw new Error(message); }
};
